
  import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
  import {UserInfo} from "@/interfaces/vuexStateInterface";
  import TodoItem from "@/components/todoList/todoItem.vue";
  import {getAllTodoList, getHomeTodoList, getSysCourseList, todoItem} from "@/apis/todoList/todoList";
  import CourseCell from "@/components/courseCell/courseCell.vue";
  import {Toast} from "vant";
  import i18n from '@/lang';

  @Component({
    components: {
      TodoItem,
      CourseCell,
    }
  })
  export default class KtpInfo extends Vue {
    private activeTab = '';
    private switchType = 'todoList'
    // private userInfo = {};
    private todoList:Array<todoItem> = [];
    private ktpPlaygroundList: Array<any> = [];
    private recommandCourseList: Array<any> = [];
    get userInfo():UserInfo {
      return this.$store.getters.getUserInfo;
    }

    changeSwitchType(type: string) {
      this.switchType = type;
    }

    created() {
    }

    getHomeTodoList() {
      return getHomeTodoList().then(res => {
        this.todoList = res.data as Array<todoItem>;
      })
    }

    tagFinished(itam:any){
      this.getHomeTodoList();
    }

    getSystemCourseList() {
      return getSysCourseList().then(res => {
        this.ktpPlaygroundList   = res.playground;
        this.recommandCourseList = res.recommand;
      })
    }

    mounted() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: false,
      });
      Promise.all([
        this.getHomeTodoList(),
        this.getSystemCourseList(),
      ]).then(() => {
        Toast.clear()
      })
    }

  }
